import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface GoodsRecommend {
	dateStart: string;
	dateEnd: string;
	minPrice: number;
	goodsNm: string;
	imageThum3: string;
	weblinkurl: string;
	goodsTp: string;
	goodsBrandCd: string;
	goodsBrandNm: string;
}

const key = "useGoodsRecommend";
/** ```
 * 상품 추천 상품 조회
 *   `/goods/{goodsCd}/recommend/{dspSid}`
 *   `/goods/{goodsCd}/recommend/{dspSid}/{webCustNo}`
 * parameter
 *   `goodsCd` 상품코드
 *   `dspSid` 메뉴코드
 *   `webCustNo?` 유저식별코드
 * ```*/
const getPath = (goodsCd: string, dspSid: string, webCustNo?: string): string | null => {
	if (!webCustNo) return `${publicRuntimeConfig.ENV_PRODUCT_API_BASEPATH}/api/goods/${goodsCd}/recommend/${dspSid}`;
	return `${publicRuntimeConfig.ENV_PRODUCT_API_BASEPATH}/api/goods/${goodsCd}/recommend/${dspSid}/${webCustNo}`;
};

/** ```
 * 상품 추천 상품 조회
 *   `/goods/{goodsCd}/recommend/{dspSid}`
 *   `/goods/{goodsCd}/recommend/{dspSid}/{webCustNo}`
 * parameter
 *   `goodsCd` 상품코드
 *   `dspSid` 메뉴코드
 *   `webCustNo?` 유저식별코드
 * ```*/
const goodsRecommendAsync = (goodsCd: string, dspSid: string, webCustNo = "") =>
	useConfigureAxios(publicRuntimeConfig.ENV_PRODUCT_API_URL + getPath(goodsCd, dspSid, webCustNo), {
		method: "GET",
	});

/** ```
 * 상품 추천 상품 조회
 *   `/goods/{goodsCd}/recommend/{dspSid}`
 *   `/goods/{goodsCd}/recommend/{dspSid}/{webCustNo}`
 * parameter
 *   `goodsCd` 상품코드
 *   `dspSid` 메뉴코드
 *   `webCustNo?` 유저식별코드
 * ```*/
const useGoodsRecommend = (
	goodsCd: string,
	dspSid: string,
	webCustNo = "",
	options?: Partial<UseQueryOptions<Response<GoodsRecommend[]>, Error>>,
) =>
	useQuery({
		queryKey: [key, getPath(goodsCd, dspSid, webCustNo)],
		queryFn: () => useConfigureAxios({url: getPath(goodsCd, dspSid, webCustNo)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});

export default useGoodsRecommend;
export {getPath, key, goodsRecommendAsync};
export type {GoodsRecommend};
